<template>
  <div class="flex flex-wrap justify-between items-center mb-9 text-xl font-bold text-text leading-tight">
    <span class="mr-4">{{ $t('myBudget') }}</span>
    <span class="text-md mt-2" v-if="isCreated">
      {{ displayCurrencyValue(widgetData.sumFact, spaceCurrency, true, true) }}
      {{ $t('moneyFrom') }}
      {{ displayCurrencyValue(widgetData.sumPlan, spaceCurrency, true, true) }}
    </span>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "MyBudgetsTitle",
  props: {
    isCreated: {
      type: Boolean,
      required: true
    },
    widgetData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  i18n: {
    messages: {
      en: {
        myBudget: 'My budget',
        moneyFrom: 'from'
      },
      ru: {
        myBudget: 'Мой бюджет',
        moneyFrom: 'из'
      }
    }
  }
}
</script>